export const shadows = (blur: number, adjustedCanvasBackground: string) => [
  `1px 1px ${blur}px ${adjustedCanvasBackground}`,
  `1px -1px ${blur}px ${adjustedCanvasBackground}`,
  `-1px 1px ${blur}px ${adjustedCanvasBackground}`,
  `-1px -1px ${blur}px ${adjustedCanvasBackground}`,
];
